import { render, staticRenderFns } from "./SubpageShell.vue?vue&type=template&id=706d855a&scoped=true&"
import script from "./SubpageShell.vue?vue&type=script&lang=js&"
export * from "./SubpageShell.vue?vue&type=script&lang=js&"
import style0 from "./SubpageShell.vue?vue&type=style&index=0&id=706d855a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "706d855a",
  null
  
)

export default component.exports